export const PROFILE_EMPLOYER_COMPANY_BANNER_UPLOAD_REQUEST =
  'profile/employer-company-banner-upload-request'
export const PROFILE_EMPLOYER_COMPANY_BANNER_UPLOAD_SUCCESS =
  'profile/employer-company-banner-upload-success'
export const PROFILE_EMPLOYER_COMPANY_BANNER_UPLOAD_FAILED =
  'profile/employer-company-banner-upload-failed'
